import { Outlet } from '@tanstack/react-router';
import { Flex, Layout, theme, Typography } from 'antd';
import { AccountMenu } from '../../features/auth/components/AccountMenu';
import { useBrand } from '../brand-context';
import { LanguageSwitcher } from './LanguageSwitcher';

export function RootLayout() {
  const brand = useBrand();
  const { token } = theme.useToken();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Layout.Header
        style={{
          background: token.colorBgContainer,
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
          paddingInline: token.paddingLG,
        }}
      >
        <Flex align="center" justify="space-between" gap="middle" style={{ height: '100%' }}>
          <Typography.Title level={4} style={{ margin: 0, color: token.colorPrimary }}>
            {brand.productName}
          </Typography.Title>
          <Flex align="center" gap="middle">
            <LanguageSwitcher />
            <AccountMenu />
          </Flex>
        </Flex>
      </Layout.Header>
      <Layout.Content style={{ padding: token.paddingLG }}>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}
